import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import SourceUserAndAvatar from './SourceUserAndAvatar';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const CenterFormattedMessage = styled(FormattedReactMessage).withConfig({
  displayName: "SourceByline__CenterFormattedMessage",
  componentId: "sc-1nzuhe0-0"
})(["display:flex;align-items:center;"]);
const SourceByline = ({
  user,
  width
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    maxInlineSize: width ? `${width}px` : undefined,
    blockSize: "18px",
    "data-test-id": "source-interpretation-user-info",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      as: "span",
      children: /*#__PURE__*/_jsx(CenterFormattedMessage, {
        message: "crm-source-interpretation-lib.userDisplay",
        options: {
          userDisplay: /*#__PURE__*/_jsx(SourceUserAndAvatar, {
            user: user
          })
        }
      })
    })
  });
};
export default SourceByline;